// extracted by mini-css-extract-plugin
export default {"checkmark":"styles_checkmark__zQ-Eu","btn":"styles_btn__HfGZQ","modalInnerHolder":"styles_modalInnerHolder__6Qwp6","title":"styles_title__MwFT4"};